module.exports = __webpack_public_path__ + "media/svg/re-49693a5f.svg";